import { api } from 'src/utils/api';

const accessPageInfoRequest = (token, action) => api.get('/debtor-area/access-page', {
    params: {
        token,
        action,
    },
});

const authenticateDebtorRequest = (token, document, action = null, refreshing = false) => api.get('/debtor-area/login', {
    params: {
        token,
        document,
        action,
        refresh: refreshing,
    },
});

const contestDebtRequest = (token, reason, action = null) => api.post('/debtor-area/contestation', {
    token,
    action,
    reason,
});

const createActionRequest = (fkDebt, fkActionType, info, action) => api.post('/debtor-area/actions', {
    fk_debt: fkDebt,
    fk_action_type: fkActionType,
    info,
    action,
});

const sendOfferToCompanyRequest = ({
    token, amount, installments, action,
}) => api.post('/debtor-area/offer', {
    token,
    amount,
    installments,
    action,
});

const loadDealInstallmentsInformationRequest = params => api.get('/debtor-area/deal-installments-information', {
    params,
});


export {
    accessPageInfoRequest,
    authenticateDebtorRequest,
    contestDebtRequest,
    sendOfferToCompanyRequest,
    createActionRequest,
    loadDealInstallmentsInformationRequest,
};
